<template>
  <WmDrawer ref="drawer" v-if="resourceVisible" :visible="resourceVisible" :title="info.displayName" :width='612' :extraStyle="{padding: '0'}"
            @close="handleCancel">
    <div class="card-container1">
      <!--自定义字段-->
      <template v-if="info.nameValues&&info.nameValues.length">
        <h3 class="blue-title">
          {{$t('page_transport_directory_custom_fields')}}
        </h3>
        <div class="custom_fields">
          <template v-for="(custom,index) in info.nameValues">
            <p :key="index">
              <a-tooltip placement="topRight" :mouseEnterDelay="0.8">
                <template slot="title">
                  <span>{{ custom.name }}</span>
                </template>
                <span class="custom ellispsis">{{ custom.name }}</span>
              </a-tooltip>
              <span class="symbol">:</span>
              <span class="value">{{ custom.value }}</span>
            </p>
          </template>
        </div>
      </template>
      <!--文件列表-->
      <template v-for="item in fileTypes">
        <div v-if="item.data.length" :key="item.name">
          <h3 class="blue-title">
            {{$t(item.locale)}}
          </h3>
          <div class="file-list-panel">
            <ul class="file-list">
              <template v-for="file in item.data">
                <li :key="file.id" @click="handleShowFileInfo(file)">
                  <div v-if="file.pic" class="img">
                    <img :src="file.pic">
                  </div>
                  <a-icon v-else class="img" :type="fileMap.default.icon"
                          theme="twoTone" :twoToneColor="fileMap.default.color"/>
                  <div class="name ellispsis">
                    <a-tooltip placement="topLeft" :mouseEnterDelay="0.5">
                      <template slot="title">
                        {{file.displayName}}
                      </template>
                      {{file.displayName}}
                    </a-tooltip>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </template>

      <!--预览文件-->
      <a-modal
              :title="$t('page_business_data_preview_doc')"
              width="680px"
              :visible="showFileInfo"
              :bodyStyle="{padding: '16px'}"
              @cancel="hiddenFileInfo"
              :maskClosable="false"

      >
        <file-preview :visible="showFileInfo" :info="fileInfo" :content="content" v-model="previewEncode"
                      :loading="previewLoading" :mode="previewMode"/>
        <template slot="footer">
          <a-button key="back" @click="hiddenFileInfo">
            {{$t('close')}}
          </a-button>
        </template>
      </a-modal>
    </div>
  </WmDrawer>
</template>

<script>
import filePreview from '../../../../components/FileTable/filePreview.vue'
import mixin from '../../../../components/FileTable/mixin.vue'

const fileMap = {
  txt: {
    icon: 'file-text',
    color: '#92a8c1'
  },
  png: {
    icon: 'file-image',
    color: '#71ce52'
  },
  jpg: {
    icon: 'file-image',
    color: '#71ce52'
  },
  pdf: {
    icon: 'file-pdf',
    color: '#ff5562'
  },
  default: {
    icon: 'file-text',
    color: '#92a8c1'
  }
}
export default {
  name: 'ResourcePanel',
  components: {
    filePreview
  },
  mixins: [mixin],
  props: {
    resourceVisible: { // 是否展示
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      docProgramVisible: true,
      docProcessVisible: true,
      docProgramFiles: [], // 加工文件
      docProcessFiles: [],  // 工艺文件
      fileTypes: [
        { name: 'docProgramFiles', data: [], locale: 'page_my_document_program' },
        { name: 'docProcessFiles', data: [], locale: 'page_my_document_process' }
      ],
      fileMap
    }
  },
  watch: {
    info: {
      handler (info) {
        // console.log('resource:', info)
        this.docProgramFiles = []
        this.docProcessFiles = []
        const val = JSON.parse(JSON.stringify(info))
        if (val.fileList && val.fileList.length) {
          val.fileList.map(file => {
            file.fileName = file.displayName
            switch (file.suffix) {
              case 'txt':
                file.pic = require('@/assets/images/file/file_txt.svg')
                break
              case 'doc':
              case 'docx':
                file.pic = require('@/assets/images/file/file_word.svg')
                break
              case 'xlsx':
                file.pic = require('@/assets/images/file/file_excel.svg')
                break
              case 'pdf':
                file.pic = require('@/assets/images/file/file_pdf.svg')
                break
              case 'png':
              case 'jpg':
              case 'jpeg':
                file.pic = require('@/assets/images/file/file_img.svg')
                break
              case 'mp4':
              case 'wmv':
              case 'avi':
              case 'ogg':
                file.pic = require('@/assets/images/file/file_video.svg')
                break
              default:
                file.pic = ''
                break
            }
            // fileType: 1：加工文件  2：工艺文件
            if (file.fileType === 1) {
              this.docProgramFiles.push(file)
            } else {
              this.docProcessFiles.push(file)
            }
          })
        }
        this.fileTypes.map(item => {
          item.data = this[item.name]
        })
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 关闭弹出
    handleCancel () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
  .card-container1 {
    overflow: auto;
    height: calc(100vh - 219px);
    position: relative;
    padding: 16px;
    padding-left: 24px;

    .blue-title {
      padding-left: 8px;
      border-left: 4px solid #457cbe;
      line-height: 22px;
      color: #457cbe;
      font-size: 14px;
    }

    .custom_fields {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin: 16px 0;
      padding-right: 28px;

      p {
        padding: 8px 0;
        display: flex;
        margin-bottom: 0;
        width: 100%;

        .custom {
          color: rgba(0, 0, 0, 0.85);
          display: block;
          width: 30%;
          text-align: right;
        }

        .symbol {
          padding-right: 8px;
          padding-left: 2px;
        }

        .value {
          max-width: 70%;
          padding: 2px 4px;
          background-color: #e6f7ff;
          border-radius: 2px;
          border: solid 1px #91d5ff;
          color: #4a90e2;
          font-size: 12px;
        }
      }
    }

    .file-list-panel {
      margin: 16px 0;
    }

    .file-list {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-bottom: -16px;
      margin-right: -16px;

      li {
        width: 145px;
        height: 146px;
        background-color: #ffffff;
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
        cursor: pointer;

        i.img {
          font-size: 62px;
        }

        .img {
          width: 64px;
          height: 64px;

          img {
            width: auto;
            height: 100%;
          }
        }

        .name {
          margin-top: 8px;
          line-height: 22px;
          color: rgba(0, 0, 0, 0.65);
          width: 100%;
          padding: 0 15px 0 20px;
          text-align: center;
        }

      }
    }
  }

</style>
